import SkinFactory from "../ui/SkinFactory";
import NavigateEvent from "./NavigateEvent";
import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";

/* 
 * Ranj Navigation Command 
 * @author Javier Quevedo-Fernandez
 * Created on 25 September 2013
 *
 */
export default class NavigateCommand {
    constructor(dispatcher, screenNavigator) {
        this.execute = function(event) {
            var navigateCommandEvent = event.params.data;
            if (isNull(navigateCommandEvent.screen)) {
                navigateCommandEvent.screen = SkinFactory.getSkin(navigateCommandEvent.screenType);
            }
            var skin = navigateCommandEvent.screen;
            switch (event.type) {
                case NavigateEvent.OPEN_SCREEN_REQUEST:
                    screenNavigator.openScreen(skin, true, navigateCommandEvent.openUnderCurrent || false, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                    break;
                case NavigateEvent.GOTO_SCREEN_REQUEST:
                    screenNavigator.gotoScreen(skin, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                    break;
                case NavigateEvent.CLOSE_SCREEN_REQUEST:
                    screenNavigator.closeScreen(skin, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                    break;
                case NavigateEvent.POP_UP_REQUEST:
                    // TODO add popup property 'customOverlayStyle'           
                    screenNavigator.openPopUp(skin, navigateCommandEvent.needsOverlay, navigateCommandEvent.priority, navigateCommandEvent.autoCenter, null, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                    break;
                case NavigateEvent.CLOSE_POP_UP_REQUEST:
                    screenNavigator.closePopUp(skin, navigateCommandEvent.animationType, navigateCommandEvent.animationOptions);
                    break;
                default:
                    log.info("[Navigate command]", "Unknown navigation command", dispatcher);
                    break;
            }
            log.info("[Navigate command]", "Navigate command executed ", dispatcher);
        };
    }
}


